import React, { useState, useEffect } from 'react';
import { Input, Button } from 'antd';

import { t } from '../../languages';
import { recordPageGA } from '../../modules/ga';
import AgeButtons from '../User/AgeButtons';

const CreateClass = ({ lang, hasTeacherSubscription, onCreate, onCancel }) => {
    const [className, setClassName] = useState('');
    const [age, setAge] = useState('');
    const [isValid, setIsValid] = useState(false);

    // Registro en Google Analytics
    useEffect(() => {
        recordPageGA('/create-class');
    }, []);

    // Validación en tiempo real
    useEffect(() => {
        setIsValid(className.trim().length >= 2 && age);
    }, [className, age]);

    const handleCreate = () => {
        if (isValid) {
            onCreate({ name: className.trim(), age });
        }
    };

    // console.log('CreateClass: currentClass:', currentClass);

    return (
        <section className="create-class-form">
            <div className="form-group">
                {/* <h3>{t(lang, 'className')}</h3> */}
                <Input
                    placeholder={t(lang, 'enterClassName')}
                    value={className}
                    onChange={(e) => setClassName(e.target.value)}
                    autoComplete="off"
                    minLength={3}
                />
            </div>
            <br />
            <br />

            <div className="form-group">
                <h3>{t(lang, 'classLevel')}</h3>
                <AgeButtons age={age} handleChangeAge={(selAge) => setAge(selAge)} />
            </div>

            <br />
            <br />

            <div className="button-group">
                <Button type="primary" className="button-blue" onClick={handleCreate} disabled={!isValid}>
                    {t(lang, 'create')}
                </Button>
                {hasTeacherSubscription ? null : <h5 style={{ textAlign: 'center' }}>{t(lang, 'firstfree')}</h5>}

            </div>
        </section>
    );
};

export default CreateClass;